import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import menusAdmin from '../../../../apis/admin/menuService';

type MenuListState = {
    menus: []
    isLoading: boolean
    detailMenus:any
}

const initialState: MenuListState = {
    menus: [],
    isLoading: false,
    detailMenus:{}
};

export const getMenuDatas = createAsyncThunk(
    'menu/ListMenuState',
    async ({fromDate, toDate, kitchenId, isSpecial}:{fromDate: any, toDate: any, kitchenId: any, isSpecial: string}) => {
        const response: any = await menusAdmin.getMenuData(fromDate, toDate, kitchenId, isSpecial);
        return response?.data?.data?.payload
    }
)

export const getMenuById = createAsyncThunk(
    'menu/getMenuById',
    async ({id}:{id:any}) => {
        const response: any = await menusAdmin.getOneMenu(id);
        return response?.data?.data?.payload
    }
)

export const menuSlice = createSlice({
    name: 'menulist',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getMenuDatas.pending, (state) => {
                state.isLoading = false
                state.menus = []
            })
            .addCase(getMenuDatas.fulfilled, (state, action: any) => {
                state.isLoading = true
                state.menus = action.payload
            })
            .addCase(getMenuById.fulfilled, (state, action: any) => {
        
                state.detailMenus = action.payload
            })
            .addCase(getMenuDatas.rejected, (state, action) => {
                state.isLoading = true
                state.menus = []
            });
        
    },
});

export default menuSlice.reducer;